(() => {
  'use strict';
  const header = document.querySelector('[data-home-header]');
  if (!header) return;
  const branches = [...header.querySelectorAll('[data-home-desktop-branch]')];
  branches.forEach(branch => {
    const toggle = branch.querySelector('summary');
    branch.addEventListener('toggle', () => {
      if (branch.open) branches.forEach(other => { if (other !== branch) other.open = false; });
    });
    branch.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      branch.open = false;
      toggle.focus();
      event.preventDefault();
    });
  });
  document.addEventListener('click', event => {
    branches.forEach(branch => { if (branch.open && !branch.contains(event.target)) branch.open = false; });
  });
  const navigation = document.getElementById('home-navigation');
  const menuTree = navigation.querySelector('[data-home-menu-tree]');
  const menuSource = JSON.parse(document.querySelector('[data-home-menu-source]').textContent);
  const menuPanels = [];
  let panelNumber = 0;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const arrow = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 21 20');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    return svg;
  };
  const showPanel = (panel, focusTarget) => {
    menuPanels.forEach(other => { other.hidden = other !== panel; });
    navigation.querySelectorAll('[data-menu-forward]').forEach(button => {
      button.setAttribute('aria-expanded', String(button.getAttribute('aria-controls') === panel.id));
    });
    panel.scrollTop = 0;
    focusTarget?.focus({preventScroll: true});
  };
  const mapMenu = (items, label, parentPanel, parentTrigger, parentHref) => {
    const panel = make('div', 'mobile-menu-panel');
    panel.id = 'home-mobile-menu-panel-' + panelNumber++;
    panel.hidden = !!parentPanel;
    menuPanels.push(panel);
    if (parentPanel) {
      const back = make('button', 'mobile-menu-back', label);
      back.type = 'button';
      back.setAttribute('aria-label', menuSource.back_label.replace('[title]', label));
      back.prepend(arrow());
      back.addEventListener('click', () => showPanel(parentPanel, parentTrigger));
      panel.append(back);
      if (parentHref && !items.some(item => item.href === parentHref)) {
        const label = parentHref === '/collections/shop-by-concern' ? menuSource.view_all_concerns_label : menuSource.view_all_label;
        const parentLink = make('a', 'mobile-menu-link', label);
        parentLink.href = parentHref;
        parentLink.dataset.menuParentRoute = '';
        panel.append(parentLink);
      }
    }
    items.forEach(item => {
      const children = item.children || [];
      if (!children.length) {
        const link = make('a', 'mobile-menu-link', item.label);
        link.href = item.href;
        panel.append(link);
        return;
      }
      const trigger = make('button', 'mobile-menu-forward', item.label);
      trigger.type = 'button';
      trigger.dataset.menuForward = '';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.append(arrow());
      const child = mapMenu(children, item.label, panel, trigger, item.href);
      trigger.setAttribute('aria-controls', child.id);
      trigger.addEventListener('click', () => showPanel(child, child.querySelector('button, a')));
      panel.append(trigger);
    });
    menuTree.append(panel);
    return panel;
  };
  const rootPanel = mapMenu(menuSource.items, '', null, null);
  let savedOverflow = '';
  let savedScrollY = 0;
  let openDialogCount = 0;
  header.querySelectorAll('[data-home-open]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const dialog = document.getElementById(trigger.dataset.homeOpen);
      if (!dialog || dialog.open) return;
      branches.forEach(branch => { branch.open = false; });
      dialog._homeTrigger = trigger;
      if (dialog === navigation) showPanel(rootPanel);
      trigger.setAttribute('aria-expanded', 'true');
      if (openDialogCount === 0) {
        savedOverflow = document.body.style.overflow;
        savedScrollY = window.scrollY;
      }
      openDialogCount += 1;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    });
  });
  document.querySelectorAll('[data-home-dialog]').forEach(dialog => {
    dialog.querySelector('[data-home-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      openDialogCount = Math.max(0, openDialogCount - 1);
      if (openDialogCount === 0) document.body.style.overflow = savedOverflow;
      if (dialog === navigation) showPanel(rootPanel);
      dialog._homeTrigger?.setAttribute('aria-expanded', 'false');
      if (openDialogCount === 0) {
        dialog._homeTrigger?.focus({preventScroll: true});
        window.scrollTo({top: savedScrollY, behavior: 'instant'});
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  });
  matchMedia('(max-width:767px)').addEventListener('change', event => {
    branches.forEach(branch => { branch.open = false; });
    if (!event.matches && navigation.open) navigation.close();
  });
})();
